import React from 'react';
import './BonusPromotion.css';

const BonusPromotion = () => {
  return (
 <div className="landing-container">
      {/* Header Section */}
      <div className="header-section-500">
        <h1 className="header-title">You’re not too small<br />to play big.</h1>

      </div>

      {/* Bonus Promo Section */}
      <div className="promo-section">
        <img
          src={require("../../../assets/offer 3 Asset .png")}
          alt="Trader"
          className="promo-image"
        />
        <div className="promo-text">
          <h2>Trade Gold, Nasdaq &
            Dow with Just $500</h2>
          <p>
            GivTrade breaks the barrier, giving everyday
            traders the power to enter premium markets
            without the premium price tag
          </p>
          <button className="claim-button"
           onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/4'}>OPEN YOUR ACCOUNT TODAY</button>
        </div>
      </div>

      {/* Mid Section */}
      <div className="mid-section">
        <div className="strategy-text">
          <h3>We’re handing you
            the key for just
            $500.</h3>
          <p>Most brokers keep the door closed until you
            deposit thousands.</p>
        </div>
        <div className="smart-traders-box">
          <h3>GivTrade <br /> low-margin execution</h3>
          <p>allows you to open 1-lot or 1-contract
            positions in top markets, such as Gold,
            Nasdaq, and Dow, with just $500.</p>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits-section">
        <h2>
          Making serious trading accessible to everyone.
        </h2>
        <div className="benefits-grid">
          <div className="benefits-column">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Trade Big with Less</strong><br />Start with just $500 to open a full lot.</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Premium Assets, Low Entry</strong><br />Get exposure to Gold, Nasdaq & Dow.</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Scalable Potential</strong><br />Small capital. Large opportunities.</p>
            </div>
          </div>
          <div className="benefits-column2">
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>Built for Dubai Traders</strong><br />Fast execution, local expertise.</p>
            </div>
            <div className="benefit-item">
              <img src={require("../../../assets/Asset 2.png")} alt="check" className="check-icon" />
              <p><strong>No Hidden Conditions</strong><br />Transparent platform. Real trades.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Final Call-to-Action Section */}
      <div className="final-cta-section">
        <h2>
         No setup fees.<br />
          <strong>No minimum deposit beyond $500.</strong>
        </h2>
        <button className="cta-button" 
         onClick={() => window.location.href = 'https://accounts.giv.trade/marketing/links/go/4'}>GET MY BONUS NOW</button>
      </div>
    </div>
  );
};

export default BonusPromotion;